import React from 'react';
import { OWN_COMPANY_NAME, OWNERSHIP_TYPES, isOwnCompany } from '../../utils/stockOwnership';
import styles from './StockManagementPage.module.css';

/**
 * Stok ekleme/düzenleme formundaki Müşteri + Proje alanları.
 * Sarf malzemesi ve demirbaş için ortaktır; demirbaşta müşteri yerine
 * firmanın kendisi de seçilebilir.
 */
const StockScopeFields = ({
  stock,
  onScopeChange,
  customers,
  projects,
  projectsForCustomer,
  hasNoMatchingProject,
}) => {
  const isFixture = stock['Kategori'] === 'demirbas';
  const customerName = stock.customerName || '';
  // Kendi firmamız seçiliyken proje listesi daraltılmaz
  const projectOptions = isOwnCompany(customerName) ? projects : projectsForCustomer(customerName);

  return (
    <>
      <div className={styles.formGroup}>
        <label className={styles.formLabel} htmlFor="stockScopeCustomer">
          {isFixture ? 'Müşteri / Firma' : 'Müşteri'}
        </label>
        <select
          id="stockScopeCustomer"
          className={styles.formSelect}
          value={customerName}
          onChange={(e) => onScopeChange('customerName', e.target.value)}
        >
          <option value="">Müşteri seçin (opsiyonel)</option>
          {isFixture && <option value={OWN_COMPANY_NAME}>{OWN_COMPANY_NAME} (Kendi firmamız)</option>}
          {customers.map((customer) => (
            <option key={customer.id} value={customer.name}>{customer.name}</option>
          ))}
        </select>
      </div>
      <div className={styles.formGroup}>
        <label className={styles.formLabel} htmlFor="stockScopeProject">Proje</label>
        <select
          id="stockScopeProject"
          className={styles.formSelect}
          value={stock.projectName || ''}
          onChange={(e) => onScopeChange('projectName', e.target.value)}
        >
          <option value="">Proje seçin (opsiyonel)</option>
          {projectOptions.map((project) => (
            <option key={project.id} value={project.name}>{project.name}</option>
          ))}
        </select>
        {projects.length === 0 ? (
          <span className={styles.scopeHint}>Proje listesi yüklenemedi.</span>
        ) : isOwnCompany(customerName) ? (
          <span className={styles.scopeHint}>
            Demirbaş firmamıza ait; kullanıldığı projeyi seçebilirsiniz.
          </span>
        ) : hasNoMatchingProject(customerName) ? (
          <span className={styles.scopeHint}>
            Bu müşteriye bağlı proje bulunamadı; tüm projeler listeleniyor.
          </span>
        ) : null}
      </div>
    </>
  );
};

/** Demirbaşın sahiplik türü: firma malı, kiralık, müşteriye ait... */
export const StockOwnershipField = ({ value, onChange }) => (
  <div className={styles.formGroup}>
    <label className={styles.formLabel} htmlFor="stockOwnershipType">Sahiplik Türü</label>
    <select
      id="stockOwnershipType"
      className={styles.formSelect}
      value={value || ''}
      onChange={(e) => onChange(e.target.value)}
    >
      <option value="">Seçin (opsiyonel)</option>
      {OWNERSHIP_TYPES.map((type) => (
        <option key={type.value} value={type.value}>{type.label}</option>
      ))}
    </select>
    <small className={styles.formHint}>Demirbaş bizim mi, kiralık mı, müşteriye mi ait?</small>
  </div>
);

export default StockScopeFields;
